import Quill from 'quill'
const Video = Quill.import('formats/video')
const Inline = Quill.import('blots/inline')
const Block = Quill.import('blots/block')

class EmbeddedVideo extends Video {
	static create (value) {
		// Patch undo issue, try to find real fix in the future.
		// See story GC-38087 for details
		if (value === true) {
			return Inline.create('')
		}
		let node = super.create(value)
		node.setAttribute('allowfullscreen', 'allowfullscreen')
		let wrap = Block.create(node)
		wrap.setAttribute('contentEditable', false)
		wrap.classList.add('embeddedvideo')
		wrap.appendChild(node)
		return wrap
	}
}

EmbeddedVideo.defaultChild = null
EmbeddedVideo.blotName = 'embeddedvideo'
EmbeddedVideo.className = 'embeddedvideo--inner'

export default EmbeddedVideo
